export function parseJSONID<T>(id: string): T {
	let resObj = null;
	try {
		resObj = JSON.parse(id);
	} catch (e) {

	}
	return resObj as T;
}

export function moveInArray<T>(arr: T[], from: number, to: number): T[] {
	const arrCopy = Array.from<T>(arr);
	if (Object.prototype.toString.call(arr) !== '[object Array]') {
		throw new Error('Please provide a valid array');
	}
	const item = arrCopy.splice(from, 1);
	if (!item.length) {
		throw new Error('There is no item in the array at index ' + from);
	}
	arrCopy.splice(to, 0, item[0]);
	return arrCopy;
}

export function extend<T>(obj: any, target: T, source: Partial<T>): T {
	if (target === source) {
		return target;
	}

	if (typeof source === 'string') {
		return source;
	}

	if (typeof source === 'boolean') {
		return source;
	}

	if (typeof source === 'number') {
		return source;
	}

	if (typeof source === 'function') {
		return source;
	}

	if (source === null) {
		return null;
	}

	if (typeof source === 'undefined') {
		return undefined;
	}

	if (Array.isArray(source) || Array.isArray(target)) {
		return source as T;
	}

	for (const prop in target) {
		if (target.hasOwnProperty(prop)) {
			obj[prop] = target[prop];
		}
	}

	for (const prop in source) {
		if (source.hasOwnProperty(prop)) {
			if (!obj[prop]) {
				obj[prop] = source[prop];

			} else if (obj[prop] !== source[prop]) {
				obj[prop] = extend({}, obj[prop] as any, source[prop] as any);
			}
		}
	}

	return obj;
}
